import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatInputModule} from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatRadioModule} from '@angular/material/radio';
import { HotTableModule } from '@handsontable/angular';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';

//services
import { AuthService } from './_service/auth.service';
import { SharedService } from './_service/shared.service';
import { LeadsService } from './_service/leads.service';
import { UserService } from './_service/user.service';
import { MessagingService } from './_service/messaging.service';


import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { ChartsModule } from 'ng2-charts';
import {MatChipsModule} from '@angular/material/chips';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './common/header/header.component';
import { LeadsComponent } from './lead_section/leads/leads.component';
import { ExcelviewComponent } from './excelview/excelview.component';
import { ProfileComponent } from './profile/profile.component';
import { ViewLeadComponent } from './lead_section/view-lead/view-lead.component';
import { EditLeadComponent } from './lead_section/edit-lead/edit-lead.component';
import { UserComponent } from './users/user/user.component';
import { SafePipe } from './_pipes/safe.pipe';
import { StatuswiseReportComponent } from './reports/statuswise-report/statuswise-report.component';
import { UpdateInsuranceModalComponent } from './insurance/update-insurance-modal/update-insurance-modal.component';
import { InsuranceListComponent } from './insurance/insurance-list/insurance-list.component';
import { OpdModalComponent } from './opd/opd-modal/opd-modal.component';
import { OpdsComponent } from './opd/opds/opds.component';
import { IpdModalComponent } from './ipd/ipd-modal/ipd-modal.component';
import { IpdsComponent } from './ipd/ipds/ipds.component';

import { CreateUserComponent } from './users/user_add_edit/user_add_edit.component';
import { ConfirmationModalComponent } from './common/confirmation-modal/confirmation-modal.component';
import { DoctorComponent } from './doctors/doctor/doctor.component';
import { HospitalComponent } from './hospitals/hospital/hospital.component';
import { AddEditdoctorsComponent } from './doctors/add-editdoctors/add-editdoctors.component';
import { AddEditHospitalComponent } from './hospitals/add-edit-hospital/add-edit-hospital.component';
import { AddEditOpdFeedbackComponent } from './opd/add-edit-opd-feedback/add-edit-opd-feedback.component';
import { AddEditIpdFeedbackComponent } from './ipd/add-edit-ipd-feedback/add-edit-ipd-feedback.component';
import { ManageCircleCityComponent } from './miscellaneous/manage-circle-city/manage-circle-city.component';
import { UpdateCircleCitiesComponent } from './miscellaneous/update-circle-cities/update-circle-cities.component';
import { ManageTreatmentsComponent } from './miscellaneous/manage-treatments/manage-treatments.component';
import { AddUpdateTreatmentComponent } from './miscellaneous/add-update-treatment/add-update-treatment.component';
import { YearlyReportComponent } from './reports/yearly-report/yearly-report.component';
import { IpdResourcesComponent } from './miscellaneous/ipd-resources/ipd-resources.component';
import { AddUpdateIpdResourcesComponent } from './miscellaneous/add-update-ipd-resources/add-update-ipd-resources.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { IpdTransactionComponent } from './ipd/ipd-transaction/ipd-transaction.component';
import { IpdTransactionReportComponent } from './reports/ipd-transaction-report/ipd-transaction-report.component';
import { LeadAssignmentSettingComponent } from './settings/lead-assignment-setting/lead-assignment-setting.component';
import { LeadAssignmentSettingModalComponent } from './settings/lead-assignment-setting-modal/lead-assignment-setting-modal.component';
import { FeedbackreportComponent } from './reports/feedbackreport/feedbackreport.component';
import { LeadKeywordsComponent } from './reports/lead-keywords/lead-keywords.component';
import { OpdDocsStatusComponent } from './opd/opd-docs-status/opd-docs-status.component';
import { TpaComponent } from './tpa/tpa.component';
import { AddEdittpaComponent } from './tpa/add-edittpa/add-edittpa.component';
import { TpaDetailsComponent } from './hospitals/tpa-details/tpa-details.component';
import { TreatmentWiseReportComponent } from './reports/treatment-wise-report/treatment-wise-report.component';
import { LeadHistoriesComponent } from './lead_section/lead-histories/lead-histories.component';
import { InsuranceCompanyComponent } from './insurance/insurance-company/insurance-company.component';
import { AddeditInsuranceCompanyComponent } from './insurance/addedit-insurance-company/addedit-insurance-company.component';
import { TpaInsuranceComponent } from './tpa/tpa-insurance/tpa-insurance.component';
import { AddeditTpaInsuranceComponent } from './tpa/addedit-tpa-insurance/addedit-tpa-insurance.component';
import { AddUpdateLocationComponent } from './miscellaneous/add-update-location/add-update-location.component';
import { ManageLocationsComponent } from './miscellaneous/manage-locations/manage-locations.component';
import { FollowDnpModalComponent } from './lead_section/follow-dnp-modal/follow-dnp-modal.component';
import { FollowDnpDetailModalComponent } from './lead_section/follow-dnp-detail-modal/follow-dnp-detail-modal.component';
import { CabDetailsComponent } from './cab/cab-details/cab-details.component';
import { CabDetailsModalComponent } from './cab/cab-details-modal/cab-details-modal.component';
import { ScanBookComponent } from './scanbook/scan-book/scan-book.component';
import { ScanBookListComponent } from './scanbook/scan-book-list/scan-book-list.component';
import { ScanUpdateModalComponent } from './scanbook/scan-update-modal/scan-update-modal.component';
import { PatientJourneyListingComponent } from './patient_journey/patient-journey-listing/patient-journey-listing.component';
import { PatientJourneyTrackerComponent } from './patient_journey/patient-journey-tracker/patient-journey-tracker.component';
import { PatientJourneyTracker2Component } from './patient_journey/patient-journey-tracker2/patient-journey-tracker2.component';
import { TodayAdmissionTodayDischargeComponent } from './patient_journey/today-admission-today-discharge/today-admission-today-discharge.component';
import { PatientJourneyCityWiseComponent } from './patient_journey/patient-journey-city-wise/patient-journey-city-wise.component';
import { UpdatePreauthModalComponent } from './insurance/update-preauth-modal/update-preauth-modal.component';
import { InsuranceTrackerListComponent } from './insurance/insurance_tracker/insurance-tracker-list/insurance-tracker-list.component';
import { AddUpdateMeetingRoomComponent } from './meeting_room/add-update-meeting-room/add-update-meeting-room.component';
import { BookedMeetingRoomListComponent } from './meeting_room/booked-meeting-room-list/booked-meeting-room-list.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CorporateLeadListComponent } from './corporate/corporate-lead-list/corporate-lead-list.component';
import { CorporateLeadAddEditComponent } from './corporate/corporate-lead-add-edit/corporate-lead-add-edit.component';
import { CorporateLeadSheetviewComponent } from './corporate/corporate-lead-sheetview/corporate-lead-sheetview.component';
import { RetailInsuranceLeadsSheetviewComponent } from './retail_insurance/retail-insurance-leads-sheetview/retail-insurance-leads-sheetview.component';
import { CrossBdComponent } from './lead_section/cross-bd/cross-bd.component';
import { AddeditLabLeadComponent } from './lab_section/addedit-lab-lead/addedit-lab-lead.component';
import { LabSheetviewComponent } from './lab_section/lab-sheetview/lab-sheetview.component';
import { LabTestModalComponent } from './lab_section/lab-test-modal/lab-test-modal.component';
import { AddLabLeadModalComponent } from './lab_section/add-lab-lead-modal/add-lab-lead-modal.component';
import { AddeditLabComponent } from './lab_section/addedit-lab/addedit-lab.component';
import { LabListComponent } from './lab_section/lab-list/lab-list.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AddSubcategoryComponent } from './lab_section/add-subcategory/add-subcategory.component';
import { AddCategoryComponent } from './lab_section/add-category/add-category.component';
import { GlamyohealthPartnersComponent } from './glamyohealth_partners/glamyohealth-partners.component';
import { PatientLoginReportComponent } from './reports/patient-login-report/patient-login-report.component';
import { PatientListComponent } from './patient/patient-list/patient-list.component';
import { PaymentSummaryComponent } from './dental_reports/payment-summary/payment-summary.component';
import { ClinicCasesComponent } from './dental_reports/clinic-cases/clinic-cases.component';
import { BucketWisePendingPaymentComponent } from './dental_reports/bucket-wise-pending-payment/bucket-wise-pending-payment.component';
import { CityBdComponent } from './cityBd/city-bd/city-bd.component';
import { CityBdTrackerComponent } from './cityBd/city-bd-tracker/city-bd-tracker.component';
import { IpdComplaintAddEditComponent } from './complaint_section/ipd-complaint-add-edit/ipd-complaint-add-edit.component';
import { ComplaintsListComponent } from './complaint_section/complaints-list/complaints-list.component';
import { UserComplaintsComponent } from './complaint_section/user-complaints/user-complaints.component';
import { RecordinglogComponent } from './recordinglog/recordinglog.component';
import { MessagesComponent } from './messages/messages.component';
import { DoctorOtherInfoComponent } from './doctors/doctor-other-info/doctor-other-info.component';
import { MemberComponent } from './member/member.component';
import { IpdPaymentModalComponent } from './ipd/ipd-payment-modal/ipd-payment-modal.component';
import { LeadsWithCallRecordingComponent } from './lead_section/leads-with-call-recording/leads-with-call-recording.component';
import { PlanShareModalComponent } from './plans/plan-share-modal/plan-share-modal.component';
import { MemberAddInsuranceTransactionComponent } from './member-add-insurance-transaction/member-add-insurance-transaction.component';
import { MemberLeadsComponent } from './member/member-leads/member-leads.component';
import { ManageCitiesComponent } from './miscellaneous/manage-cities/manage-cities.component';
import { AddEditPincodeComponent } from './master_pin_code/add-edit-pincode/add-edit-pincode.component';
import { MasterPinCodeListComponent } from './master_pin_code/master-pin-code-list/master-pin-code-list.component';
import { MasterZoneListComponent } from './master_zone/master-zone-list/master-zone-list.component';
import { AddEditZoneComponent } from './master_zone/add-edit-zone/add-edit-zone.component';
import { AddEditPincodeMachineMasterComponent } from './pincode_machine_master/add-edit-pincode-machine-master/add-edit-pincode-machine-master.component';
import { ListPincodeMachineMasterComponent } from './pincode_machine_master/list-pincode-machine-master/list-pincode-machine-master.component';
import { AddEditScanMachineComponent } from './master-machine/add-edit-scan-machine/add-edit-scan-machine.component';
import { ScanMachineListComponent } from './master-machine/scan-machine-list/scan-machine-list.component';

import { OpdPrescriptionAuditComponent } from './opd/opd-prescription-audit/opd-prescription-audit.component';
import { PlanLeadListComponent } from './plans/plan-lead-list/plan-lead-list.component';
import { AddEditPlanLeadComponent } from './plans/add-edit-plan-lead/add-edit-plan-lead.component';
import { WhatsappMessageComponent } from './messages/whatsapp-message/whatsapp-message.component';
import { PlanOutHistoryComponent } from './scanbook/plan-out-history/plan-out-history.component';
import { MoveSurgeryLeadComponent } from './lab_section/move-surgery-lead/move-surgery-lead.component';
import { KnowledgeBaseComponent } from './one_stop_solution/knowledge-base/knowledge-base.component';
import { CommonObjectionsRebuttalsComponent } from './one_stop_solution/common-objections-rebuttals/common-objections-rebuttals.component';
import { EligibilityCriteriaBajajComponent } from './one_stop_solution/eligibility-criteria-bajaj/eligibility-criteria-bajaj.component';
import { CrmDispositionListComponent } from './one_stop_solution/crm-disposition-list/crm-disposition-list.component';
import { CtocReportComponent } from './reports/ctoc-report/ctoc-report.component';
import { PerformanceReportComponent } from './reports/performance-report/performance-report.component';
import { GlamyoPartnerLeadsComponent } from './glamyo-partner/glamyo-partner-leads/glamyo-partner-leads.component';
import { MovePartnerLeadsComponent } from './glamyo-partner/move-partner-leads/move-partner-leads.component';
import { ManageHelpComponent } from './one_stop_solution/manage-help/manage-help.component';
import { AddEditHelpComponent } from './one_stop_solution/add-edit-help/add-edit-help.component';
import { ScanPaymentModalComponent } from './scanbook/scan-payment-modal/scan-payment-modal.component';
import { CommonSettingComponent } from './common-setting/common-setting/common-setting.component';
import { CommonSettingSidebarComponent } from './common-setting/common-setting-sidebar/common-setting-sidebar.component';
import { CommonSmsSettingComponent } from './common-setting/common-sms-setting/common-sms-setting.component';
import { AppWalletSettingComponent } from './common-setting/app-wallet-setting/app-wallet-setting.component';
import { TransactionComponent } from './transaction/transaction.component';
import { AddEditTransactionComponent } from './transaction/add-edit-transaction/add-edit-transaction.component';
import { LabPaymentModalComponent } from './lab_section/lab-payment-modal/lab-payment-modal.component';
import { CategoryWiseIpdReportFeedbackComponent } from './reports/category-wise-ipd-report-feedback/category-wise-ipd-report-feedback.component';
import { ScanReportComponent } from './dental_reports/scan-report/scan-report.component';
import { AppointmentComponent } from './doctors/appointment/appointment.component';
import { AddEditPincodeScanproMasterComponent } from './pincode-scanpro-master/add-edit-pincode-scanpro-master/add-edit-pincode-scanpro-master.component';
import { ListPincodeScanproMasterComponent } from './pincode-scanpro-master/list-pincode-scanpro-master/list-pincode-scanpro-master.component';
import { DentalOrthodontistReportComponent } from './dental_reports/dental-orthodontist-report/dental-orthodontist-report.component';
import { UserStatusWiseReportComponent } from './reports/user-status-wise-report/user-status-wise-report.component';
import { ManageBridgeNumberComponent } from './miscellaneous/manage-bridge-number/manage-bridge-number.component';
import { BdWiseReportComponent } from './reports/bd-wise-report/bd-wise-report.component';
import { LeadDetailsComponent } from './lead_section/lead-details/lead-details.component';
import { AddUpdateSpecialtiesComponent } from './miscellaneous/add-update-specialties/add-update-specialties.component';
import { SpecialtiesComponent } from './miscellaneous/specialties/specialties.component';
import { SpokRemarksComponent } from './scanbook/spok-remarks/spok-remarks.component';
import { PatientJourneyDetailsComponent } from './ipd/patient-journey-details/patient-journey-details.component';
import { ShareHealthProductPaymentlinkComponent } from './lead_section/share-health-product-paymentlink/share-health-product-paymentlink.component';
import { ManageLocalitiesComponent } from './miscellaneous/manage-localities/manage-localities.component';
import { UpdateAdminLeadDetailsComponent } from './lead_section/update-admin-lead-details/update-admin-lead-details.component';
import { AddEditAffiliateUserComponent } from './users/add-edit-affiliate-user/add-edit-affiliate-user.component';
import { AffiliateComponent } from './affiliate_section/affiliate/affiliate.component';
import { AffiliateLeadsComponent } from './affiliate_section/affiliate-leads/affiliate-leads.component';
import { AffiliateOpdsComponent } from './affiliate_section/affiliate-opds/affiliate-opds.component';
import { AffiliateIpdsComponent } from './affiliate_section/affiliate-ipds/affiliate-ipds.component';
import { ProductModelComponent } from './product_section/product-model/product-model.component';
import { ProductsComponent } from './product_section/products/products.component';
import { ScanProAssignmentComponent } from './scanbook/scan-pro-assignment/scan-pro-assignment.component';
import { PlanPackageComponent } from './miscellaneous/plan-package/plan-package.component';
import { PlanPackageAddEditComponent } from './miscellaneous/plan-package-add-edit/plan-package-add-edit.component';
import { PushDataToNimbusComponent } from './lead_section/push-data-to-nimbus/push-data-to-nimbus.component';
import { ProductTrackModelComponent } from './product_section/product-track-model/product-track-model.component';
import { OdsScanLogsComponent } from './ods-scan/ods-scan-logs/ods-scan-logs.component';
import { UpdateOdsScanLogsComponent } from './ods-scan/update-ods-scan-logs/update-ods-scan-logs.component';
import { ScanBookCaseHistoryComponent } from './scanbook/scan-book-case-history/scan-book-case-history.component';
import { HairRemovalModelComponent } from './hair_removal_section/hair-removal-model/hair-removal-model.component';
import { HairRemovalComponent } from './hair_removal_section/hair-removal/hair-removal.component';
import { DispositionAnalysisComponent } from './dental_reports/disposition-analysis/disposition-analysis.component';
import { HairRemovalPaymentModalComponent } from './hair_removal_section/hair-removal-payment-modal/hair-removal-payment-modal.component';
import { FeedbackTappingReportComponent } from './reports/feedback-tapping-report/feedback-tapping-report.component';
import { PaymentReportComponent } from './dental_reports/payment-report/payment-report.component';
import { AccountsRemarksComponent } from './scanbook/accounts-remarks/accounts-remarks.component';
import { EmiReportComponent } from './reports/emi-report/emi-report.component';



@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    HeaderComponent,
    LeadsComponent,
    ExcelviewComponent,
    ProfileComponent,
    ViewLeadComponent,
    EditLeadComponent,
    UserComponent,
    SafePipe,
    StatuswiseReportComponent,
    UpdateInsuranceModalComponent,
    InsuranceListComponent,
    OpdModalComponent,
    OpdsComponent,
    IpdModalComponent,
    IpdsComponent,
    CreateUserComponent,
    ConfirmationModalComponent,
    DoctorComponent,
    HospitalComponent,
    AddEditdoctorsComponent,
    AddEditHospitalComponent,
    AddEditOpdFeedbackComponent,
    AddEditIpdFeedbackComponent,
    ManageCircleCityComponent,
    UpdateCircleCitiesComponent,
    ManageTreatmentsComponent,
    AddUpdateTreatmentComponent,
    YearlyReportComponent,
    IpdResourcesComponent,
    AddUpdateIpdResourcesComponent,
    IpdTransactionComponent,
    IpdTransactionReportComponent,
    LeadAssignmentSettingComponent,
    LeadAssignmentSettingModalComponent,
    FeedbackreportComponent,
    LeadKeywordsComponent,
    OpdDocsStatusComponent,
    TpaComponent,
    AddEdittpaComponent,
    TpaDetailsComponent,
    TreatmentWiseReportComponent,
    LeadHistoriesComponent,
    InsuranceCompanyComponent,
    AddeditInsuranceCompanyComponent,
    TpaInsuranceComponent,
    AddeditTpaInsuranceComponent,
    AddUpdateLocationComponent,
    ManageLocationsComponent,
    FollowDnpModalComponent,
    FollowDnpDetailModalComponent,
    CabDetailsComponent,
    CabDetailsModalComponent,
    ScanBookComponent,
    ScanBookListComponent,
    ScanUpdateModalComponent,
    PatientJourneyListingComponent,
    PatientJourneyTrackerComponent,
    PatientJourneyTracker2Component,
    TodayAdmissionTodayDischargeComponent,
    PatientJourneyCityWiseComponent,
    UpdatePreauthModalComponent,
    InsuranceTrackerListComponent,
    AddUpdateMeetingRoomComponent,
    BookedMeetingRoomListComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    CorporateLeadListComponent,
    CorporateLeadAddEditComponent,
    CorporateLeadSheetviewComponent,
    RetailInsuranceLeadsSheetviewComponent,
    CrossBdComponent,
    AddeditLabLeadComponent,
    LabSheetviewComponent,
    LabTestModalComponent,
    AddLabLeadModalComponent,
    AddeditLabComponent,
    LabListComponent,
    AddSubcategoryComponent,
    AddCategoryComponent,
    GlamyohealthPartnersComponent,
    PatientLoginReportComponent,
    PatientListComponent,
    PaymentSummaryComponent,
    ClinicCasesComponent,
    BucketWisePendingPaymentComponent,
    CityBdComponent,
    CityBdTrackerComponent,
    IpdComplaintAddEditComponent,
    ComplaintsListComponent,
    UserComplaintsComponent,
    RecordinglogComponent,
    MessagesComponent,
    DoctorOtherInfoComponent,
    MemberComponent,
    IpdPaymentModalComponent,
    LeadsWithCallRecordingComponent,
    PlanShareModalComponent,
    MemberAddInsuranceTransactionComponent,
    MemberLeadsComponent,
    ManageCitiesComponent,
    AddEditPincodeComponent,
    MasterPinCodeListComponent,
    MasterZoneListComponent,
    AddEditZoneComponent,
    AddEditPincodeMachineMasterComponent,
    ListPincodeMachineMasterComponent,
    AddEditScanMachineComponent,
    ScanMachineListComponent,
    OpdPrescriptionAuditComponent,
    PlanLeadListComponent,
    AddEditPlanLeadComponent,
    WhatsappMessageComponent,
    PlanOutHistoryComponent,
    MoveSurgeryLeadComponent,
    KnowledgeBaseComponent,
    CommonObjectionsRebuttalsComponent,
    EligibilityCriteriaBajajComponent,
    CrmDispositionListComponent,
    CtocReportComponent,
    PerformanceReportComponent,
    GlamyoPartnerLeadsComponent,
    MovePartnerLeadsComponent,
    ManageHelpComponent,
    AddEditHelpComponent,
    ScanPaymentModalComponent,
    CommonSettingComponent,
    CommonSettingSidebarComponent,
    CommonSmsSettingComponent,
    AppWalletSettingComponent,
    TransactionComponent,
    AddEditTransactionComponent,
    LabPaymentModalComponent,
    CategoryWiseIpdReportFeedbackComponent,
    ScanReportComponent,
    AppointmentComponent,
    AddEditPincodeScanproMasterComponent,
    ListPincodeScanproMasterComponent,
    DentalOrthodontistReportComponent,
    UserStatusWiseReportComponent,
    ManageBridgeNumberComponent,
    BdWiseReportComponent,
    LeadDetailsComponent,
    AddUpdateSpecialtiesComponent,
    SpecialtiesComponent,
    SpokRemarksComponent,
    PatientJourneyDetailsComponent,
    ShareHealthProductPaymentlinkComponent,
    ManageLocalitiesComponent,
    UpdateAdminLeadDetailsComponent,
    AddEditAffiliateUserComponent,
    AffiliateComponent,
    AffiliateLeadsComponent,
    AffiliateOpdsComponent,
    AffiliateIpdsComponent,
    ProductModelComponent,
    ProductsComponent,
    ScanProAssignmentComponent,
    PlanPackageComponent,
    PlanPackageAddEditComponent,
    PushDataToNimbusComponent,
    ProductTrackModelComponent,
    OdsScanLogsComponent,
    UpdateOdsScanLogsComponent,
    ScanBookCaseHistoryComponent,
    HairRemovalModelComponent,
    HairRemovalComponent,
    DispositionAnalysisComponent,
    HairRemovalPaymentModalComponent,
    FeedbackTappingReportComponent,
    PaymentReportComponent,
    AccountsRemarksComponent,
    EmiReportComponent,

  ],
  imports: [
    BrowserModule,ClipboardModule,DragDropModule,ChartsModule, 
    AppRoutingModule,HotTableModule,MatExpansionModule,MatDialogModule,MatRadioModule,NgxMatSelectSearchModule,
    BrowserAnimationsModule,HttpClientModule,MatSelectModule,MatDatepickerModule,
    MatSnackBarModule,MatPaginatorModule,MatProgressSpinnerModule,MatNativeDateModule,CKEditorModule,
    FormsModule,ReactiveFormsModule,MatAutocompleteModule,MatTabsModule,MatIconModule,MatSlideToggleModule,MatChipsModule,MatCardModule,MatButtonToggleModule,ConfirmationPopoverModule.forRoot({
      confirmButtonType: "danger" // set defaults here
    }),
    MatInputModule,AngularFireMessagingModule,AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [DatePipe,AuthService,SharedService,LeadsService,UserService,MessagingService],
  bootstrap: [AppComponent]
})
export class AppModule { }
